import { api } from '@/shared/api/client';
import type { SearchResponse } from './types';

// Slice-307: thin wrapper. The api() helper attaches the bearer token; the BE
// SearchService pulls warehouse/owner from TenantContext for scoping.
export const searchApi = {
  search(q: string, limit = 5): Promise<SearchResponse> {
    const p = new URLSearchParams({ q, limit: String(limit) });
    return api<SearchResponse>(`/api/v1/search?${p.toString()}`);
  },
};
